import { Box, Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { MapboxGeoJSONFeature } from "react-map-gl";

interface EasementsTableProps {
  intersectingEasements: MapboxGeoJSONFeature[];
}
export const EasementsTable = (props: EasementsTableProps) => {
  return (
    <Box width="100%">
      <Typography variant="h6">Easements on Parcel</Typography>
      <div style={{ maxHeight: "200px", overflow: "auto" }}>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="p-1 text-left font-bold">
                Contributer ID
              </TableHead>
              <TableHead className="p-1 text-left font-bold">State</TableHead>
              <TableHead className="p-1 text-left font-bold">
                Contributor Type
              </TableHead>
              {props.intersectingEasements[0].geometry.type == "LineString" && (
                <TableHead className="p-1 text-left font-bold">
                  Length
                </TableHead>
              )}
              {props.intersectingEasements[0].geometry.type == "Polygon" && (
                <TableHead className="p-1 text-left font-bold">Area</TableHead>
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {props.intersectingEasements.map((easement) => (
              <>
                {easement.properties && (
                  <TableRow
                    key={
                      easement.geometry.type == "LineString"
                        ? easement.properties.easement_line_pid
                        : easement.properties.easement_polygon_pid
                    }
                  >
                    <TableCell className="p-1 text-left">
                      {easement.properties.contributor_id}
                    </TableCell>
                    <TableCell className="p-1 text-left">
                      {easement.properties.state}
                    </TableCell>
                    <TableCell className="p-1 text-left">
                      {easement.properties.contributor_type}
                    </TableCell>
                    {easement.geometry.type == "LineString" && (
                      <TableCell className="p-1 text-left">
                        {`${easement.properties.length} m`}
                      </TableCell>
                    )}
                    {easement.geometry.type == "Polygon" && (
                      <TableCell className="p-1 text-left">
                        {`${easement.properties.area} m²`}
                      </TableCell>
                    )}
                  </TableRow>
                )}
              </>
            ))}
          </TableBody>
        </Table>
      </div>
    </Box>
  );
};
